module.exports = __webpack_public_path__ + "static/media/46_brass_metal_seamless.80975a18.jpg";